import { GenericAction, GenericActionWithPayload } from "./action-types";
import { Fee } from "./basket";
import { Branch } from "./branch";

type DeliveryMethod = "pending" | "home_delivery" | "offline_drive_thru";

export type DeliveryStatus =
  | "pending"
  | "collecting"
  | "prepared"
  | "scanned"
  | "out_for_delivery"
  | "delivered"
  | "failed"
  | "placed"
  | "rejected";

type Delivery = {
  status: DeliveryStatus;
};

type PickupStatus = {
  status: string;
};

export type OrderLineType = {
  productId: number;
  quantity: number;
  total: number;
};

export type DriverStatus = {
  id: number;
  fullName: string;
  telephone: string;
  latitude: number;
  longitude: number;
  vehicle: {
    id: number;
    plateNumber: string;
    make: string;
    model: string;
    year?: number;
    color?: string;
  };
  order: {
    latitude: number;
    longitude: number;
  };
};

type GroupBasket = {
  id: number;
  guestName: string;
  items: OrderLineType[];
  state: string;
  total?: number;
};

export type BasketLineItemType = {
  id: string;
  productId: string;
  variationId?: number;
  price?: number;
  quantity: number;
  parentId?: number;
  children?: number[];
  _isUnavailable?: boolean;
};

type OrderType = {
  id: number;
  deliveryMethod: DeliveryMethod;
  branch?: Branch;
  albaikIdentifier: number;
  pickupCode: string;
  createdAt: number;
  collectAt?: number;
  pickupAt?: number;
  delivery: Delivery;
  pickup?: PickupStatus;
  ticketNumber: number;
  restaurantId: number;
  status: string;
  itemsSubtotal: number;
  itemsTax: number;
  itemsTotal: number;
  feesTax: number;
  feesTotal: number;
  total: number;
  tax: number;
  taxPercent: number;
  url: string;
  items: OrderLineType[];
  fees: Fee[];
  driverStatus?: DriverStatus;
  baskets?: GroupBasket[];
};

type LaneInfo = {
  id: number;
  name: string;
};

type Order = Omit<
  OrderType,
  | "itemsSubtotal"
  | "itemsTax"
  | "itemsTotal"
  | "feesTax"
  | "feesTotal"
  | "fees"
  | "baskets"
> & {
  backupPin: string;
  subtotal: number;
  lane?: LaneInfo;
};

type OrderState = {
  all: Order[];
  ordersLoading: boolean;
  currentPage: number;
  isOrderProcessing: boolean;
};

type AddOrdersAction = GenericActionWithPayload<"ORDERS_ADD", Order[]>;

type CreateOrderDoneAction = GenericActionWithPayload<
  "ORDER_CREATE_DONE",
  Order
>;

type CreateOrderStartAction = GenericAction<"ORDER_CREATE_START">;

type OrdersFetchAction = GenericActionWithPayload<"ORDERS_FETCH", boolean>;

type IncrementOrderCurrentPageAction =
  GenericAction<"INCREMENT_ORDER_CURRENT_PAGE">;

type ResetOrderCurrentPageAction = GenericAction<"RESET_ORDER_CURRENT_PAGE">;

type OrderAction =
  | AddOrdersAction
  | CreateOrderDoneAction
  | CreateOrderStartAction
  | OrdersFetchAction
  | IncrementOrderCurrentPageAction
  | ResetOrderCurrentPageAction
  | GenericAction<"SIGNOUT">
  | GenericAction<"ASYNC_ORDER_COMPLETED">
  | GenericAction<"ASYNC_ORDER_FAILED">;

export type {
  OrderType,
  OrderState,
  Order,
  OrderAction,
  OrdersFetchAction,
  IncrementOrderCurrentPageAction,
  ResetOrderCurrentPageAction,
};
